var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-page',{ref:"loginPage",attrs:{"post-login-route":""},scopedSlots:_vm._u([{key:"formLinks",fn:function(){return [_c('div')]},proxy:true},{key:"loginForm",fn:function(){return [(_vm.method === 'email')?_c('verify-code-component'):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }